import axios from './instance'

export const getAllSubdepartment = async () => {
  try {
    const res = await axios.get(`http://localhost:8000/api/subdepartments/all`);
    return res.data;
  } catch (error) {
    console.error("Error fetching sub departments:", error);
    throw error;
  }
};

export const getSubdepartment = async (deparmentID) => {
  try {
    const res = await axios.get(`http://localhost:8000/api/subdepartments/${deparmentID}`);
    return res?.data;
  } catch (error) {
    console.error("Error fetching sub departments:", error);
    throw error;
  }
};


export const createSubDepartment = async (subDepartmentData) => {
  try {
    const res = await axios.post(`http://localhost:8000/api/subdepartments`, subDepartmentData);
    return res.data;
  } catch (error) {
    console.error("Error creating sub-department:", error);
    throw error;
  }
};

export const updateSubDepartment = async (subDepartmentID, subDepartmentData) => {
  try {
    const res = await axios.patch(`http://localhost:8000/api/subdepartments/${subDepartmentID}`, subDepartmentData);
    return res.data;
  } catch (error) {
    console.error(`Error updating sub-department with ID ${subDepartmentID}:`, error);
    throw error;
  }
};

export const deleteSubDepartment = async (subDepartmentID) => {
  try {
    const res = await axios.delete(`http://localhost:8000/api/subdepartments/${subDepartmentID}`);
    return res.data;
  } catch (error) {
    console.error(`Error deleting sub-department with ID ${subDepartmentID}:`, error);
    throw error;
  }
};
